import { useEffect, useMemo, useRef, useState } from 'react';
import InputBox from '../../../component/InputBox';
import SelectionBox from '../../../component/SelectionBox';
import { CODE_GROUP_ID, ENROLMENT_REG_STATUS } from '../../../constant/Constant';
import CodeUtil from '../../../util/CodeUtil';
import ExcelDownloadButtonBox from '../../../component/buttons/ExcelDownloadButtonBox';
import ExcelUploadButtonBox from '../../../component/buttons/ExcelUploadButtonBox';
import AuthenticationUtil from '../../../util/AuthenticationUtil';
import EnrolmentStatusSubjectModal from '../../modal/EnrolmentStatusSubjectModal';
import { modalType } from '../../../util/ModalUtil';
import ModalRef from '../../../component/ModalRef';
import { useDispatch, useSelector } from 'react-redux';
import {
    actionExcelDownload,
    actionExcelUpload,
    actionSearch,
    actionEditEnrolmentRegStatusCd,
} from '../../../module/body/semester/SemesterEnrolmentStatusViewTab2BodyModule';
import SearchButtonBox from '../../../component/buttons/SearchButtonBox';
import { IconButton, Tooltip } from '@material-ui/core';
import SessionStorageUtil from '../../../util/SessionStorageUtil';
import TableBox from '../../../component/TableBox';
import { handleControl, defaultGridData, handleGridData, initGrid } from '../../../module/component/TableBoxModule';
import StatusTextIconBox from '../../../component/StatusTextIconBox';
import GridButtonBox from '../../../component/buttons/GridButtonBox';
import { OpenEditIcon } from '../../../component/icon/GridIcons';
import PathUtil from '../../../util/PathUtil';
import qs from 'qs';
import { useLocation } from 'react-router-dom';
import NullCheckUtil from '../../../util/NullCheckUtil';
import PopupRef from '../../../component/PopupRef';

const ConditionArea = ({ tabNo, popupRef, modalRef }) => {
    const location = useLocation();
    const queryData = qs.parse(location.search, { ignoreQueryPrefix: true });
    const [semesterId, setSemesterId] = useState(SessionStorageUtil.getCurrentSemesterId());
    const lessonUniversityCd = AuthenticationUtil.getUserUniversityCd();
    const [subjectNm, setSubjectNm] = useState('');
    const [userUniversityCd, setUserUniversityCd] = useState('');
    const [enrolmentRegStatusCd, setEnrolmentRegStatusCd] = useState('');
    const [userNm, setUserNm] = useState('');
    const [params, setParams] = useState({});

    const { gridData } = useSelector((state) => state.tableBoxState);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(
            handleControl({
                columns,
                onRowDoubleClick,
                onChangePageInfo,
                params,
            }),
        );

        queryData.userUniversityCd && setUserUniversityCd(queryData.userUniversityCd);
        queryData.enrolmentRegStatusCd && setEnrolmentRegStatusCd(queryData.enrolmentRegStatusCd);
        queryData.subjectNm && setSubjectNm(queryData.subjectNm);
        queryData.userNm && setUserNm(queryData.userNm);

        onClick({
            semesterId,
            lessonUniversityCd,
            userUniversityCd: queryData.userUniversityCd,
            enrolmentRegStatusCd: queryData.enrolmentRegStatusCd,
            subjectNm: queryData.subjectNm,
            userNm: queryData.userNm,
            page: NullCheckUtil.isNotNull(queryData.page) ? queryData.page : defaultGridData.page,
            pageSize: NullCheckUtil.isNotNull(queryData.pageSize) ? queryData.pageSize : 100,
        });

        return () => {
            dispatch(initGrid());
        };
    }, []);

    useEffect(() => {
        dispatch(
            handleControl({
                columns,
                onRowDoubleClick,
                onChangePageInfo,
                params,
            }),
        );
    }, [params]);

    const onChangePageInfo = (page, pageSize) => {
        onClick({
            ...params,
            page,
            pageSize,
        });
    };

    const onClick = (params) => {
        setParams(params);
        dispatch(
            actionSearch({
                params,
                callback: (result) => {
                    if (result.totalCount == 0) {
                        popupRef.current.openAlert('조회된 결과가 없습니다.');
                    }
                },
            }),
        );
        PathUtil.pushState(location.pathname, { ...params, tabNo });
    };

    const onRowDoubleClick = (row, params) => {
        modalRef.current.open(
            <EnrolmentStatusSubjectModal
                row={row}
                type={modalType.EDIT}
                modalRef={modalRef}
                callback={() => {
                    onClick(params);
                }}
            />,
            'medium',
        );
    };

    const handleDownload = () => {
        dispatch(actionExcelDownload({ params }));
    };

    const errMsg = (oldEnrolmentRegStatusCd, newEnrolmentRegStatusCd) => {
        const oldEnrolmentRegStatusCdNm = CodeUtil.getCodeName(
            CODE_GROUP_ID.ENROLMENT_REG_STATUS,
            oldEnrolmentRegStatusCd,
        );
        const newEnrolmentRegStatusCdNm = CodeUtil.getCodeName(
            CODE_GROUP_ID.ENROLMENT_REG_STATUS,
            newEnrolmentRegStatusCd,
        );
        return (
            oldEnrolmentRegStatusCdNm +
            ' 상태를 ' +
            newEnrolmentRegStatusCdNm +
            ' 상태로 변경 불가합니다. 강제로 변경 하려면 우측의 수정 버튼을 눌러 상세 페이지에서 변경해 주세요.'
        );
    };

    const requestService = (row, newValue, params) => {
        dispatch(
            actionEditEnrolmentRegStatusCd({
                data: {
                    semesterId: row.semesterId,
                    lessonUniversityCd: row.lessonUniversityCd,
                    subjectId: row.subjectId,
                    classNo: row.classNo,
                    userId: row.userId,
                    universitySubjectId: row.universitySubjectId,
                    enrolmentRegStatusCd: newValue,
                    force: false,
                },
                callback: () => {
                    onClick(params);
                },
            }),
        );
    };

    const openAlert = (row, newValue) => {
        popupRef.current.openAlert(errMsg(row.enrolmentRegStatusCd, newValue));
    };

    const handleEnrolmentRegStatusCd = (row, newValue, params) => {
        if (ENROLMENT_REG_STATUS.WAITING === row.enrolmentRegStatusCd) {
            if (
                !(
                    ENROLMENT_REG_STATUS.REGIST === newValue ||
                    ENROLMENT_REG_STATUS.REJECT === newValue ||
                    ENROLMENT_REG_STATUS.WAITING === newValue
                )
            ) {
                openAlert(row, newValue);
            } else {
                requestService(row, newValue, params);
            }
        } else if (ENROLMENT_REG_STATUS.REGIST === row.enrolmentRegStatusCd) {
            if (
                !(
                    ENROLMENT_REG_STATUS.WITHDRAW === newValue ||
                    ENROLMENT_REG_STATUS.REGIST === newValue ||
                    ENROLMENT_REG_STATUS.REJECT === newValue
                )
            ) {
                openAlert(row, newValue);
            } else {
                requestService(row, newValue, params);
            }
        } else if (ENROLMENT_REG_STATUS.REJECT === row.enrolmentRegStatusCd) {
            if (
                !(
                    ENROLMENT_REG_STATUS.WAITING === newValue ||
                    ENROLMENT_REG_STATUS.REGIST === newValue ||
                    ENROLMENT_REG_STATUS.REJECT === newValue
                )
            ) {
                openAlert(row, newValue);
            } else {
                requestService(row, newValue, params);
            }
        } else if (ENROLMENT_REG_STATUS.WITHDRAW === row.enrolmentRegStatusCd) {
            if (!(ENROLMENT_REG_STATUS.WITHDRAW === newValue || ENROLMENT_REG_STATUS.REGIST === newValue)) {
                openAlert(row, newValue);
            } else {
                requestService(row, newValue, params);
            }
        } else {
            requestService(row, newValue, params);
        }
    };

    const onKeyDown = (e) => {
        if (e.key == 'Enter') {
            onClick({
                semesterId,
                lessonUniversityCd,
                userUniversityCd,
                enrolmentRegStatusCd,
                subjectNm,
                userNm,
                page: defaultGridData.page,
                pageSize: gridData.pageSize,
            });
        }
    };

    const columns = useMemo(
        () => [
            {
                field: 'semesterId',
                headerName: '학기',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 14,
                renderCell: (params) => CodeUtil.getCodeName(CODE_GROUP_ID.SEMESTER, params.row.semesterId),
            },
            {
                field: 'subjectNm',
                headerName: '개설대학교과목',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 20,
            },
            { field: 'classNo', headerName: '분반', headerAlign: 'center', align: 'center', tooltip: true, flex: 6 },
            { field: 'profNm', headerName: '교강사', headerAlign: 'center', align: 'center', tooltip: true, flex: 8 },
            { field: 'creditCnt', headerName: '학점', headerAlign: 'center', align: 'center', tooltip: true, flex: 6 },
            {
                field: 'userUniversityCd',
                headerName: '소속대학',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
                renderCell: (params) =>
                    CodeUtil.getCodeName(CODE_GROUP_ID.USER_UNIVERSITY, params.row.userUniversityCd),
            },
            {
                field: 'majorDeptNm',
                headerName: '소속대학 전공(학과)',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
            },

            {
                field: 'studentId',
                headerName: '소속대학 학번',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
            },
            {
                field: 'userNm',
                headerName: '이름',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
            },
            {
                field: 'enrolmentValidStatusCd',
                headerName: '본교수강검증',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 12,
                renderCell: (params) => (
                    <StatusTextIconBox
                        codeGroup={CODE_GROUP_ID.ENROLMENT_VALID_STATUS}
                        statusCd={params.row.enrolmentValidStatusCd}
                    />
                ),
            },
            {
                field: 'lessonUniversityStudentId',
                headerName: '개설대학학번',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
            },
            {
                field: 'enrolmentRegDttm',
                headerName: '수강신청일시',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 15,
            },
            {
                field: 'enrolmentRegStatusCd',
                headerName: '수강등록상태',
                headerAlign: 'center',
                align: 'center',
                // tooltip: true,
                flex: 10,
                renderCell: (params) => (
                    <StatusTextIconBox
                        codeGroup={CODE_GROUP_ID.ENROLMENT_REG_STATUS}
                        statusCd={params.row.enrolmentRegStatusCd}
                    />
                ),
            },
            {
                field: 'RegStatusReqAction',
                headerName: '등록요청처리',
                headerAlign: 'center',
                align: 'center',
                // tooltip: true,
                flex: 16,
                renderCell: (item) => (
                    <>
                        <GridButtonBox
                            title='등록완료'
                            btnStyle='REGIST'
                            onClick={(e) => handleEnrolmentRegStatusCd(item.row, ENROLMENT_REG_STATUS.REGIST, params)}
                        />
                        <GridButtonBox
                            title='반려'
                            btnStyle='REJECT'
                            onClick={(e) => handleEnrolmentRegStatusCd(item.row, ENROLMENT_REG_STATUS.REJECT, params)}
                        />
                    </>
                ),
            },
            {
                field: 'RegStatusWithDrawAction',
                headerName: '수강취소처리',
                headerAlign: 'center',
                align: 'center',
                // tooltip: true,
                flex: 10,
                renderCell: (item) => (
                    <>
                        <GridButtonBox
                            title='수강취소'
                            btnStyle='WITHDRAW'
                            onClick={(e) => handleEnrolmentRegStatusCd(item.row, ENROLMENT_REG_STATUS.WITHDRAW, params)}
                        />
                    </>
                ),
            },
            {
                field: 'detail',
                headerName: '기능',
                headerAlign: 'center',
                align: 'center',
                flex: 6,
                disableColumnMenu: true,
                hideSortIcons: true,
                disableExport: true,
                renderCell: (item) => (
                    <>
                        <Tooltip title='수정'>
                            <IconButton onClick={() => onRowDoubleClick(item.row, params)}>
                                <OpenEditIcon />
                            </IconButton>
                        </Tooltip>
                    </>
                ),
            },
        ],
        [params],
    );

    return (
        <div className='tab-body'>
            <div className='con-form-wrap'>
                <div className='board-inner'>
                    <div className='board-row'>
                        <div className='lec-check-box'>
                            <div className='form-box-container'>
                                <SelectionBox
                                    title='학기'
                                    value={semesterId}
                                    options={CodeUtil.getCodes(CODE_GROUP_ID.SEMESTER)}
                                    onChange={(e) => setSemesterId(e.target.value)}
                                    useAll={true}
                                    onKeyDown={(e) => onKeyDown(e)}
                                />
                                <SelectionBox
                                    title='소속대학'
                                    w140
                                    value={userUniversityCd}
                                    options={CodeUtil.getCodes(CODE_GROUP_ID.USER_UNIVERSITY)}
                                    onChange={(e) => setUserUniversityCd(e.target.value)}
                                    onKeyDown={(e) => onKeyDown(e)}
                                />
                                <SelectionBox
                                    title='수강등록상태'
                                    w140
                                    value={enrolmentRegStatusCd}
                                    options={CodeUtil.getCodes(CODE_GROUP_ID.ENROLMENT_REG_STATUS)}
                                    onChange={(e) => setEnrolmentRegStatusCd(e.target.value)}
                                    onKeyDown={(e) => onKeyDown(e)}
                                />
                                <InputBox
                                    title='교과목'
                                    value={subjectNm}
                                    onChange={(e) => setSubjectNm(e.target.value)}
                                    onKeyDown={(e) => onKeyDown(e)}
                                />
                                <InputBox
                                    title='이름'
                                    value={userNm}
                                    onChange={(e) => setUserNm(e.target.value)}
                                    onKeyDown={(e) => onKeyDown(e)}
                                />
                            </div>
                            <div className='lec-check-btn'>
                                <SearchButtonBox
                                    title='조회'
                                    onClick={(e) =>
                                        onClick({
                                            semesterId,
                                            lessonUniversityCd,
                                            userUniversityCd,
                                            enrolmentRegStatusCd,
                                            subjectNm,
                                            userNm,
                                            page: defaultGridData.page,
                                            pageSize: gridData.pageSize,
                                        })
                                    }
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='con-tb-wrap'>
                <div className='con-tb-title  '>
                    <h3 className='tb-tit-name'>학점교류 수강신청 목록</h3>
                    <div className='btn-group'>
                        <ExcelDownloadButtonBox onClick={(e) => handleDownload()} />
                        <ExcelUploadButtonBox
                            params={{ semesterId }}
                            callback={(e) => {
                                onClick({
                                    semesterId,
                                    lessonUniversityCd,
                                    userUniversityCd,
                                    enrolmentRegStatusCd,
                                    subjectNm,
                                    userNm,
                                    page: defaultGridData.page,
                                    pageSize: gridData.pageSize,
                                });
                            }}
                            module={actionExcelUpload}
                        />
                    </div>
                </div>
                <div className='comment-box'>
                    <ul>
                        <li>
                            수강신청 학생의 학번 발급 확인 후, 수강신청 목록을 다운받아 교무처와 협의하여 수강등록을
                            진행합니다.
                        </li>
                        <li>수강 등록이 완료되면 수강등록상태를 변경합니다. </li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

const SemesterEnrolmentStatusViewTab2Body = ({ tabNo }) => {
    const modalRef = useRef(null);
    const popupRef = useRef(null);

    return (
        <div>
            <ConditionArea tabNo={tabNo} popupRef={popupRef} modalRef={modalRef} />
            <TableBox />
            <PopupRef ref={popupRef} />
            <ModalRef ref={modalRef} />
        </div>
    );
};

export default SemesterEnrolmentStatusViewTab2Body;
